<template>
  <div>
    <base-modal-bottom
      ref="modal"
      :on-close="updateRsvps"
      title="Excluir convidado(s)"
    >
      <template #btn-close-icon>
        <base-icon
          style="margin: 0 auto"
          width="16"
          height="16"
          name="painel/close-icon"
        />
      </template>

      <div v-if="actionLoading && !success" class="has-text-centered">
        <base-reload
          :isReload="false"
          :dark="true"
          label="Estamos excluindo, aguarde um pouquinho..."
        />
      </div>

      <div
        v-else-if="!actionLoading && !success"
        class="c-guests-delete-guest has-text-centered"
      >
        <div class="margin-bottom">
          <div class="c-guests-delete-guest__header">
            <h6 class="is-size-5 has-text-weight-bold has-text-grey-darker">
              Excluir convidado
            </h6>
            <p class="margin-bottom">
              Selecione o(s) convidado(s) que desejar cancelar a presença
            </p>
          </div>

          <ul class="c-guests-delete-guest__list">
            <li
              v-for="(guest, index) in guestsCheckbox"
              :key="index"
              @click="selectGuestToDelete(index)"
              class="checkbox is-flex has-text-grey-darker"
            >
              <BaseCheckbox :checked="guest.checked" />
              {{ guest.name }}
            </li>
          </ul>
        </div>

        <div
          class="c-guests-delete-guest__buttons columns is-centered has-text-centered"
        >
          <div class="column">
            <button
              @click="deleteGuests"
              type="button"
              class="button is-primary is-big is-fullwidth"
            >
              Excluir convidado(s)
            </button>
          </div>
          <div class="column">
            <button
              @click="close"
              type="button"
              class="button is-outlined is-big is-fullwidth"
            >
              Cancelar
            </button>
          </div>
        </div>
      </div>

      <div v-else>
        <div class="c-guests-delete-guest-rsvp has-text-centered">
          <base-icon
            style="margin: 0 auto 1em"
            width="80"
            height="80"
            class="has-text-success"
            name="painel/check-circle-icon"
          />

          <p class="is-size-4" style="margin-bottom: 2em">
            <strong class="has-text-grey-darker">
              Os convidados selecionados foram<br />excluídos da sua lista com
              sucesso!
            </strong>
          </p>

          <button @click="close" type="button" class="button is-primary is-big">
            Ok
          </button>
        </div>
      </div>
    </base-modal-bottom>
    <BaseModalError
      ref="errorApi"
      title="Erro ao excluir convidado(s)"
      icon="error-api"
      :message="errorOnDeleteGuests"
    />
  </div>
</template>

<script>
import BaseModalBottom from '@/components/BaseModalBottom.vue'
import BaseModalError from '@/components/BaseModalError.vue'
import BaseCheckbox from '@/components/BaseCheckbox.vue'

import RsvpApi from '@/lib/api/Rsvp'

export default {
  props: {
    guests: {
      type: Array,
    },
  },

  components: {
    BaseModalBottom,
    BaseCheckbox,
    BaseModalError,
  },

  computed: {
    logonToken() {
      return this.$store.state.app.logonToken
    },

    rsvps: {
      get() {
        return this.$store.state.rsvp.rsvps
      },

      set(payload) {
        this.$store.dispatch('setRsvps', payload)
      },
    },
  },

  data() {
    return {
      guestsCheckbox: [],
      success: false,
      errorOnDeleteGuests: '<strong>Estamos com problemas!</strong>',
      actionLoading: false,
    }
  },

  methods: {
    open() {
      this.success = false
      this.setCheckboxConfig()
      this.$refs.modal.open()
    },

    close() {
      this.$refs.modal.close()
    },

    deleteGuests() {
      this.actionLoading = true
      const rsvpApi = new RsvpApi(this.logonToken)
      let errors = false

      const guestsChecked = this.guestsCheckbox.filter((guest) => guest.checked)

      Promise.all(
        guestsChecked.map((guest) => {
          return rsvpApi
            .deleteGuest(guest.id)
            .then((response) => response.data)
            .catch((err) => err)
        })
      )
        .then((dataOrErrors) => {
          dataOrErrors.forEach((dataOrError) => {
            if (!dataOrError.data) errors = true
          })
        })
        .finally(() => {
          if (!errors) {
            this.success = true
          } else {
            this.close()
            this.$refs.errorApi.open()
          }
          this.actionLoading = false
        })
    },

    updateRsvps() {
      if (this.success) {
        const rsvpApi = new RsvpApi(this.logonToken)
        rsvpApi.getRsvps().then((response) => {
          this.rsvps = response.data.data
        })
      }
    },

    selectGuestToDelete(index) {
      this.guestsCheckbox[index].checked = !this.guestsCheckbox[index].checked
    },

    setCheckboxConfig() {
      this.guestsCheckbox = []
      this.guests.forEach((guest) => {
        this.guestsCheckbox.push({
          id: guest.id,
          name: guest.name,
          checked: false,
        })
      })
    },
  },
}
</script>

<style lang="scss">
.c-guests-delete-guest {
  margin: 0 auto;
  max-width: 500px;

  &__header {
    margin-bottom: 1.5em;
  }

  &__buttons {
    margin: 1.5em auto 0;
    max-width: 480px;
    flex-direction: row-reverse;
  }
}
</style>
